export const modalDescriptions = {
  airport: {
    title: 'Что входит в наш аэропортный трансфер?',
    subtitle: '✈️ Аэропортный трансфер',
    image: '/img/modalDescription/airport.webp',
    imageAlt: 'Автомобиль для аэропортного трансфера',
    ariaLabel: {
      orderButton: 'Перейти к форме бронирования аэропортного трансфера',
      orderButtonText: 'Заказать трансфер',
      closeButton: 'Закрыть модальное окно',
    },
    list: [
      'Водитель встретит с табличкой у выхода из терминала.',
      'Помощь с багажом.',
      'Отслеживание рейса (мы знаем, если рейс задерживается).',
      'Ожидание до 60 минут бесплатно.',
      'Автомобили премиум-класса (Wi-Fi, вода, детское кресло по запросу).',
      'Доступные направления: из/в аэропорт Вацлава Гавела.',
      'Цены от 30 евро.',
    ],
    text: 'Наш трансфер в аэропорт — это гарантия спокойного начала или завершения вашей поездки. Мы отслеживаем ваш рейс и встречаем вас с табличкой в зоне прилёта. Водитель поможет с багажом и доставит вас в комфортабельном автомобиле с Wi-Fi прямо к дверям. Первый час ожидания бесплатен, так что можно не волноваться в случае задержки.',
  },

  corporate: {
    title: 'Идеальное решение для бизнеса',
    subtitle: '🧑‍💼 Корпоративный трансфер',
    image: '/img/modalDescription/corporate.webp',
    imageAlt: 'Автомобиль бизнес-класса для корпоративных клиентов',
    ariaLabel: {
      orderButton: 'Перейти к форме бронирования корпоративного трансфера',
      orderButtonText: 'Заказать трансфер',
      closeButton: 'Закрыть модальное окно',
    },
    list: [
      'Обслуживание корпоративных клиентов.',
      'Возможность заключения контракта с компанией.',
      'Ежемесячная отчётность и оплата по счёту.',
      'Водители в костюмах, конфиденциальность поездок.',
      'Автомобили от бизнес-класса и выше.',
      'Возможность заказа на мероприятия, конференции, делегации.',
      'Отслеживание маршрута через корпоративный кабинет.',
    ],
    text: 'Мы предлагаем премиальный сервис для компаний, ценящих комфорт и пунктуальность. Трансферы между отелями, конференц-залами и аэропортом выполняются профессиональными водителями с опытом обслуживания VIP-клиентов. Возможна оплата по счёту и заключение договора. Ваши сотрудники будут доставлены вовремя и с максимальной безопасностью.',
  },

  personal: {
    title: 'Ваш водитель на день, неделю или поездку',
    subtitle: '🚗 Персональный водитель',
    image: '/img/modalDescription/personal.webp',
    imageAlt: 'Персональный водитель с автомобилем премиум-класса',
    ariaLabel: {
      orderButton: 'Перейти к форме бронирования персонального водителя',
      orderButtonText: 'Заказать водителя',
      closeButton: 'Закрыть модальное окно',
    },
    list: [
      'Можно арендовать водителя почасово / на весь день.',
      'Поездки по городу, остановки, ожидание — всё включено.',
      'Автомобили премиум-класса с водителем.',
      'Частные поездки, шопинг-туры, важные встречи.',
      'Идеально для гостей города, VIP-клиентов, пожилых людей.',
      'Водители говорят на английском/чешском языках.',
    ],
    text: 'Аренда персонального водителя — идеальное решение для тех, кто хочет свободу передвижения без лишних забот. Наш водитель будет сопровождать вас на протяжении всего маршрута, независимо от его сложности. Вы можете заказать сопровождение на шопинг, деловые встречи или загородную поездку. Премиум-авто, вежливый сервис и полная конфиденциальность — всё включено.',
  },

  vip: {
    title: 'Роскошь и комфорт премиум-класса',
    subtitle: '👑 VIP и люкс-услуги',
    image: '/img/modalDescription/vip.webp',
    imageAlt: 'Автомобиль VIP-класса, готовый к поездке',
    ariaLabel: {
      orderButton: 'Перейти к форме бронирования VIP-услуги',
      orderButtonText: 'Заказать VIP трансфер',
      closeButton: 'Закрыть модальное окно',
    },
    list: [
      'Персонализированный подход к каждому клиенту.',
      'Автомобили высшего класса.',
      'Водители в костюмах с опытом обслуживания VIP-гостей.',
      'Полная конфиденциальность.',
      'Дополнительные опции: welcome-набор, минеральная вода, газеты.',
      'Идеально для встреч с бизнес-партнёрами, дипломатических визитов, свадеб и светских мероприятий.',
      'Поддержка 24/7 и личный менеджер.',
    ],
    text: 'Аренда персонального водителя — идеальное решение для тех, кто хочет свободу передвижения без лишних забот. Наш водитель будет сопровождать вас на протяжении всего маршрута, независимо от его сложности. Вы можете заказать сопровождение на шопинг, деловые встречи или загородную поездку. Премиум-авто, вежливый сервис и полная конфиденциальность — всё включено.',
  },

  tours: {
    title: 'Путешествуйте с комфортом и удовольствием',
    subtitle: '🌍 Туры и экскурсии',
    image: '/img/modalDescription/vip.webp',
    imageAlt: 'Автомобиль для туров и экскурсий по Европе',
    ariaLabel: {
      orderButton: 'Перейти к форме бронирования тура или экскурсии',
      orderButtonText: 'Заказать тур',
      closeButton: 'Закрыть модальное окно',
    },
    list: [
      'Организация индивидуальных и групповых туров.',
      'Возможность выбрать гида или только водителя.',
      'Гибкие маршруты по Чехии и Европе (Карловы Вары, Вена, Дрезден, Мюнхен и др.).',
      'Комфортабельные автомобили, кондиционер, Wi-Fi, питьевая вода.',
      'Фото-паузы, время на шопинг, питание в местных ресторанах.',
      'Туристическая страховка и поддержка в пути.',
      'Возможность бронирования через онлайн-форму.',
    ],
    text: 'Откройте для себя Европу вместе с нами — без стресса и лишних забот. Мы организуем индивидуальные или групповые туры в соответствии с вашими интересами и пожеланиями. Наши гиды могут сопровождать вас, или вы просто насладитесь комфортной поездкой с профессиональным водителем. Все маршруты созданы с акцентом на удобство, безопасность и яркие впечатления.',
  },
};
